// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NUHWB","rootMobile":"styles_rootMobile__3iIUq"};